<template>
  <v-card class="px-3 py-2">
    <v-card
      class="d-flex justify-space-between align-center pa-2"
      flat
      tile
    >
      <div
        class=""
        style="width:200px;"
      >
        <span class="text-subtitle-2 font-weight-bold">{{ $t("m.speedFuel") }}</span>
      </div>
      <v-select
        class="ml-6"
        :items="shipInfoArr"
        :label="$t('m.selectVessel')"
        outlined
        dense
        hide-details
        v-model="shipInfo.ShipID"
        clearable
        @click:clear="shipInfo.ShipID = ''"
        @click="openShipList()"
        item-text="SHIPNAME"
        item-value="SHIPID"
      />

      <v-select
        v-if="speedVisible"
        class="ml-6"
        :items="speedTypeArr"
        :label="$t('m.speed')"
        outlined
        dense
        hide-details
        v-model="shipInfo.SpeedType"
        item-text="text"
        item-value="val"
      />

      <v-text-field
        class="ml-6"
        dense
        outlined
        hide-details
        type="number"
        v-model="shipInfo.SpeedBallast"
        :value="$store.state.estimating.shipInfo.SpeedBallast"
        :label="$t('m.speedBallast')"
        :suffix="$t('m.knots')"
      />

      <v-text-field
        class="ml-6"
        dense
        outlined
        hide-details
        type="number"
        v-model="shipInfo.SpeedLaden"
        :value="$store.state.estimating.shipInfo.SpeedLaden"
        :label="$t('m.speedLaden')"
        :suffix="$t('m.knots')"
      />
    </v-card> <!-- end 船舶选择 第一层 -->

    <v-card
      class="d-flex justify-space-between mt-2 mb-2"
      flat
      tile
    >
      <v-card
        class=""
        flat
        tile
        :disabled="cardDisabled"
      >
        <v-row
          dense
          class="text-body-2"
        >
          <v-col
            cols="4"
            offset="4"
          >
            {{ $t('m.foConsump') }}
          </v-col>
          <v-col cols="4">
            {{ $t('m.doConsumpForEsti') }}
          </v-col>
        </v-row>
        <v-row
          dense
          align="center"
          class="mt-0"
        >
          <v-col
            cols="4"
            class="text-body-2"
          >
            {{ $t('m.seaLaden') }}
          </v-col>
          <v-col cols="4">
            <v-text-field
              dense
              hide-details
              type="number"
              v-model="shipInfo.FOLaden"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              dense
              hide-details
              type="number"
              v-model="shipInfo.DOBallast"
            />
          </v-col>
        </v-row>
        <v-row
          align="center"
          dense
          class="mt-0"
        >
          <v-col
            cols="4"
            class="text-body-2"
          >
            {{ $t('m.seaBallast') }}
          </v-col>
          <v-col cols="4">
            <v-text-field
              dense
              hide-details
              type="number"
              v-model="shipInfo.FOBallast"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              dense
              hide-details
              disabled
              type="number"
              v-model="shipInfo.DOSea"
            />
          </v-col>
        </v-row>
        <v-row
          align="center"
          dense
          class="mt-0"
        >
          <v-col
            cols="4"
            class="text-body-2"
          >
            {{ $t('m.atPortIdle') }}
          </v-col>
          <v-col cols="4">
            <v-text-field
              dense
              hide-details
              type="number"
              v-model="shipInfo.FOPortIdle"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              dense
              hide-details
              type="number"
              v-model="shipInfo.DOPortIdle"
            />
          </v-col>
        </v-row>
        <v-row
          align="center"
          dense
          class="mt-0"
        >
          <v-col
            cols="4"
            class="text-body-2"
          >
            {{ $t('m.atPortWork') }}
          </v-col>
          <v-col cols="4">
            <v-text-field
              dense
              hide-details
              type="number"
              v-model="shipInfo.FOPortWork"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              dense
              hide-details
              type="number"
              v-model="shipInfo.DOPortWork"
            />
          </v-col>
        </v-row>
      </v-card> <!-- 列表 row -->

      <v-card
        class="ml-12"
        flat
        tile
      >
        <v-row
          dense
          class="text-body-2"
        >
          <v-col
            cols="4"
            offset="4"
          >
            {{ $t('m.fo') }}
          </v-col>
          <v-col cols="4">
            {{ $t('m.do') }}
          </v-col>
        </v-row>
        <v-row
          align="center"
          dense
          class="mt-0"
        >
          <v-col
            cols="4"
            class="text-body-2"
          >
            {{ $t('m.consumption') }}
          </v-col>
          <v-col cols="4">
            <v-text-field
              dense
              hide-details
              :value="fuelConsump.foConsump"
              disabled
              :suffix="$t('m.ton')"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              dense
              hide-details
              :value="fuelConsump.doConsump"
              disabled
              :suffix="$t('m.ton')"
            />
          </v-col>
        </v-row>
        <v-row
          align="center"
          dense
          class="mt-0"
        >
          <v-col
            cols="4"
            class="text-body-2"
          >
            {{ $t('m.price') }}
          </v-col>
          <v-col cols="4">
            <v-text-field
              dense
              hide-details
              v-model="$store.state.estimating.foPrice"
              :suffix="'/'+$t('m.ton')"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              dense
              hide-details
              v-model="$store.state.estimating.doPrice"
              :suffix="'/'+$t('m.ton')"
            />
          </v-col>
        </v-row>
        <v-row
          align="center"
          dense
          class="mt-0"
        >
          <v-col
            cols="4"
            class="text-body-2"
          >
            {{ $t('m.cost') }}
          </v-col>
          <v-col cols="4">
            <v-text-field
              dense
              disabled
              hide-details
              :value="fuelCost.foFee"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              dense
              disabled
              hide-details
              :value="fuelCost.doFee"
            />
          </v-col>
        </v-row>
      </v-card> <!-- 列表 row -->
    </v-card> <!-- end 第 二层 -->
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Utils from '@/utils/index'
import httpClient from '@/api/httpClient'
import Constant from '@/constant'
import EstiTmpl from '@/components/estimation/EstiTmpl'

export default {
  name: 'VesselParticularPad',
  components: { },
  props: [
    'model', 'visible'
  ],
  data () {
    return {
      shipInfo: this._.cloneDeep(EstiTmpl.FUEL_FORM),
      cardDisabled: false,
      speedVisible: false,
      speedTypeArr: [{
        val: '1', text: this.$t('m.speedFull')
      }, {
        val: '2', text: this.$t('m.speedEco')
      }],
      shipInfoArr: [],
      currSelectedShip: null
    }
  },
  created () {
    // this.queryVesselArr() //应该每次使用的时候查询
  },
  computed: {
    ...mapState({
      isRotating: state => state.estimating.isRotating,
      isGettedDistance: state => state.estimating.isGettedDistance,
      editFlag: state => state.estimating.editFlag,
      resetMessage: state => state.estimating.resetMessage,
      clearFlag: state => state.estimating.clearFlag,
      saveAsFlag: state => state.estimating.saveAsFlag
    }),
    ...mapGetters({
      fuelConsump: 'getFuelConsumption',
      fuelCost: 'getFuelCost'
    })

  },
  watch: {
    model: function (val) {
      if (val) {
        this.resetForm()
      } else {
        this.clearForm()
      }
    },
    clearFlag: function (val) {
      if (val) this.clearForm()
    },

    'shipInfo.ShipID': function (val) {
      if (val) { // 选了船舶
        this.cardDisabled = true
        this.speedVisible = true
        this.currSelectedShip = this.shipInfoArr.find(ele => ele.SHIPID == val)
        this.fillByVessel()
      } else {
        this.cardDisabled = false
        this.speedVisible = false
        this.currSelectedShip = null
        this.shipInfo = this._.cloneDeep(EstiTmpl.FUEL_FORM)
      }
      this.handleAllCommit()
    },

    'shipInfo.SpeedType': function (val) {
      this.fillByVessel()
    },

    'shipInfo.SpeedBallast': function (val) {
      this.handleAllCommit()
    },
    'shipInfo.SpeedLaden': function (val) {
      this.handleAllCommit()
    },

    'shipInfo.DOBallast': function (val) {
      this.shipInfo.DOSea = val
      this.handleAllCommit()
    },
    'shipInfo.DOPortIdle': function (val) {
      this.handleAllCommit()
    },
    'shipInfo.DOPortWork': function (val) {
      this.handleAllCommit()
    },

    'shipInfo.FOBallast': function (val) {
      this.handleAllCommit()
    },
    'shipInfo.FOLaden': function (val) {
      this.handleAllCommit()
    },
    'shipInfo.FOPortIdle': function (val) {
      this.handleAllCommit()
    },
    'shipInfo.FOPortWork': function (val) {
      this.handleAllCommit()
    }

  },
  methods: {
    queryVesselArr () {
      var json = {
        OperID: Utils.getWithExpiry('operID')
      }
      httpClient.post('/SIShipInfoQry', json)
        .then((res) => {
          this.shipInfoArr = res.data
        }).catch((err) => {
          // this.shipInfoArr = []
        })
    },

    openShipList () {
      this.queryVesselArr()
    },

    handleAllCommit () {
      this.$store.commit('updateEstiShipInfo', this.shipInfo)
    },

    fillByVessel () {
      if (!this.currSelectedShip) return

      this.shipInfo.ShipName = this.currSelectedShip.SHIPNAME
      this.shipInfo.DOBallast = this.currSelectedShip.DOBALLAST
      this.shipInfo.DOPortIdle = this.currSelectedShip.DOPORTIDLE
      this.shipInfo.DOPortWork = this.currSelectedShip.DOPORTWORK
      this.shipInfo.DOSea = this.currSelectedShip.DOLADEN
      this.shipInfo.FOPortIdle = this.currSelectedShip.FOPORTIDLE
      this.shipInfo.FOPortWork = this.currSelectedShip.FOPORTWORK

      if (this.shipInfo.SpeedType == '1') { // 全速
        this.shipInfo.SpeedBallast = this.currSelectedShip.BALLASTFULLSPEED
        this.shipInfo.SpeedLaden = this.currSelectedShip.LADENFULLSPEED
        this.shipInfo.FOBallast = this.currSelectedShip.FOFULLBALLAST
        this.shipInfo.FOLaden = this.currSelectedShip.FOFULLLADEN
      } else {
        this.shipInfo.SpeedBallast = this.currSelectedShip.BALLASTECOSPEED
        this.shipInfo.SpeedLaden = this.currSelectedShip.LADENECOSPEED
        this.shipInfo.FOBallast = this.currSelectedShip.FOECOBALLAST
        this.shipInfo.FOLaden = this.currSelectedShip.FOECOLADEN
      }
    },

    resetForm () {
      this.shipInfo = this.model.ESTICONTENT.vesselData
    },

    clearForm () {
      this.shipInfo = this._.cloneDeep(EstiTmpl.FUEL_FORM)
      this.cardDisabled = false
      this.speedVisible = false
      // this.shipInfoArr = []
      this.currSelectedShip = null
    }
  }

}
</script>

<style scoped>

</style>
